import React from 'react';
import { jsx } from '@emotion/core';
import moment from 'moment';
import { IProvider } from '../../../utils/types';
import DataTable from '../../../components/table/DataTable';
/**@jsx jsx*/

type Actions = {
  className?: string;
  label: string;
  action: (provider: IProvider) => void;
}[];

interface IProps {
  providers?: IProvider[];
  actions: Actions;
  isLoading?: boolean;
}

const columns = [
  {
    title: 'Id',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
  },
  {
    title: 'Channel',
    dataIndex: 'channel',
    key: 'channel',
  },
  {
    title: 'Created At',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (createdAt: Date) => {
      return <span>{moment(createdAt).format('DD/MM/YYYY')}</span>;
    },
  },
  {
    title: 'Last Changed',
    dataIndex: 'lastChanged',
    key: 'lastChanged',
    render: (lastChanged: Date) => {
      return <span>{moment(lastChanged).format('DD/MM/YYYY')}</span>;
    },
  },
];

const PaymentProvidersTable: React.FC<IProps> = ({
  providers = [],
  actions,
  isLoading,
}) => {
  return (
    <DataTable
      showControls
      showPagination
      data={providers}
      columns={columns}
      actions={actions}
      searchFilter="name"
      isLoading={isLoading}></DataTable>
  );
};

export default PaymentProvidersTable;
